(function ($) {
  $("a.uk-navbar-toggle").on("click", function () {
    // switch the background color to white colour
    $(".header-container").toggleClass("mobile-white-header");

    // Prevent scrolling when menu is open
    $("body").toggleClass("no-scroll");
  });
  
})(jQuery);
